module.exports = __webpack_public_path__ + "static/img/AI_Meridian_Chair.d21412cb.png";